export const MASTER_KEY_OWNER_EMAIL = 'brad@enhanced.ai';

export interface MasterApiKeyStatus {
  exists: boolean;
  prefix: string | null;
  lastRotatedAt: string | null;
  isActive: boolean;
}
